import React from "react";

const Login = React.lazy(() => import("../pages/auth/SignIn"));
const SignUp = React.lazy(() => import("../pages/auth/SignUp"));
const ForgotPassword = React.lazy(() => import("../pages/auth/ForgotPassword"));
const Home = React.lazy(() => import("../pages/home"));
const Products = React.lazy(() => import("../pages/products"));
const ProductDetails = React.lazy(() => import("../pages/productDetails"));
const Cart = React.lazy(() => import("../pages/cart"));
const Checkout = React.lazy(() => import("../pages/checkout"));
const MyAccount = React.lazy(() => import("../pages/myAccount"));
const Location = React.lazy(() => import("../pages/location"));
const OrderDetails = React.lazy(() => import("../pages/orders/OrderDetails"));
const MobileOrDynamicService = React.lazy(() => import("../pages/mobileOrDynamicService"));
const Blog = React.lazy(() => import("../pages/blog"));
const BlogDetails = React.lazy(() => import("../pages/blog/BlogDetails"));
const AboutUs = React.lazy(() => import("../pages/aboutUs"));
const ContactUs = React.lazy(() => import("../pages/contactUs"));
const Feedback = React.lazy(() => import("../pages/feedback"));
const PrivacyPolicy = React.lazy(() => import("../pages/privacyPolicy"));
const ReturnPolicy = React.lazy(() => import("../pages/returnPolicy"));
const ShippingPolicy = React.lazy(() => import("../pages/shippingPolicy"));
const TermsCondition = React.lazy(() => import("../pages/termsCondition"));
const ThankYou = React.lazy(() => import("../pages/thankYou"));
const CheckoutZipPay = React.lazy(() => import("../pages/checkoutZipPay"));
const PaymentFail = React.lazy(() => import("../pages/paymentFail"));
const Quote = React.lazy(() => import("../pages/quote"));
const Error404 = React.lazy(() => import("../pages/Error404"));
const Error500 = React.lazy(() => import("../pages/Error500"));

export const ROUTES = {
  SIGN_IN: {
    path: "/login",
    element: <Login />,
    isProtected: false,
  },
  SIGN_UP: {
    path: "/sign-up",
    element: <SignUp />,
    isProtected: false,
  },
  FORGOT_PASSWORD: {
    path: "/forgot-password",
    element: <ForgotPassword />,
    isProtected: false,
  },
  HOME: {
    path: "/home",
    element: <Home />,
    isProtected: false,
  },
  PRODUCTS: {
    path: "/products/*",
    element: <Products />,
    isProtected: false,
  },
  PRODUCT_DETAILS: {
    path: "/product-details/:slug",
    element: <ProductDetails />,
    isProtected: false,
  },
  MY_ACCOUNT: {
    path: "/my-account",
    element: <MyAccount />,
    isProtected: true,
  },
  CART_PAGE: {
    path: "/cart",
    element: <Cart />,
    isProtected: false,
  },
  CHECKOUT: {
    path: "/checkout",
    element: <Checkout />,
    isProtected: false,
  },
  ORDER_DETAILS: {
    path: "/order-details/:orderId",
    element: <OrderDetails />,
    isProtected: false,
  },
  LOCATION: {
    path: "/location/:stateId",
    element: <Location />,
    isProtected: false,
  },
  MOBILE_OR_DYNAMIC_SERVICES: {
    path: "/services/:param",
    element: <MobileOrDynamicService />,
    isProtected: false,
  },
  BLOG: {
    path: "/blog",
    element: <Blog />,
    isProtected: false,
  },
  BLOG_POST: {
    path: "/blog/:slug",
    element: <BlogDetails />,
    isProtected: false,
  },
  ABOUT_US: {
    path: "/about-us",
    element: <AboutUs />,
    isProtected: false,
  },
  CONTACT_US: {
    path: "/contact-us",
    element: <ContactUs />,
    isProtected: false,
  },
  FEEDBACK: {
    path: "/feedback",
    element: <Feedback />,
    isProtected: false,
  },
  PRIVACY_POLICY: {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
    isProtected: false,
  },
  SHIPPING_POLICY: {
    path: "/shipping-policy",
    element: <ShippingPolicy />,
    isProtected: false,
  },
  RETURN_POLICY: {
    path: "/return-policy",
    element: <ReturnPolicy />,
    isProtected: false,
  },
  TERMS_CONDITION: {
    path: "/terms-condition",
    element: <TermsCondition />,
    isProtected: false,
  },
  THANK_YOU: {
    path: "/thank-you/:uniqueId",
    element: <ThankYou />,
    isProtected: false,
  },
  PAYMENT_FAILURE: {
    path: "/payment-fail",
    element: <PaymentFail />,
    isProtected: false,
  },
  CHECKOUT_ZIP_PAY: {
    path: "/checkout-zippay",
    element: <CheckoutZipPay />,
    isProtected: false,
  },
  QUOTE: {
    path: "/quote/:uniqueId",
    element: <Quote />,
    isProtected: false,
  },
  ERROR404: {
    path: "/404",
    element: <Error404 />,
    isProtected: false,
  },
  ERROR500: {
    path: "/500",
    element: <Error500 />,
    isProtected: false,
  },
}

export const routes = Object.values(ROUTES);